/* Orela pick-a-card popup -> Klaviyo (Client Subscriptions API).
   v2 2026-10-31: Rosabella's Alia "pick a card" popup rebuilt for Orela (Grahym: "lets make our pop up like this and
   designe dlike this"). Flow, as theirs: 6 face-down cards -> the visitor flips 3, every card is the welcome prize, so
   3 flips are always a match -> "You've got a <prize> gift card" + email -> (SMS, only when smsEnabled) -> You're In!
   The behaviour around it is unchanged from v1 (1Bag's scratch popup, ported 2026-10-07): the same timing, flags,
   Klaviyo calls, SMS-pending save, focus trap, scroll lock. v1 is in ~/Projects/orela-klaviyo/before_popup_v2_20261031/.
   Config comes from <script id="orp-pop-config" type="application/json"> rendered by snippets/klaviyo-popup.liquid.
   No dependencies. Nothing is fetched until the popup is about to open. */
(function () {
  'use strict';

  var root = document.getElementById('orp-pop');
  var cfgEl = document.getElementById('orp-pop-config');
  if (!root || !cfgEl || root.getAttribute('data-orp-init')) return;
  root.setAttribute('data-orp-init', '1');

  var CFG = {
    publicKey: '',
    listId: '',
    smsEnabled: false,
    smsLive: true,
    delayMs: 5000,  // Grahym 2026-10-20: "make it pop up at like 10 seconds in"; 2026-10-31: "actually 5 seconds in"
    // the delay starts at window load, or this long after DOMContentLoaded, whichever comes first,
    // so a heavy page (big GIFs) still gets the popup a few seconds in
    readyCapMs: 1000,
    dismissDays: 30,
    excludePaths: [],
    logoUrl: '',
    bottleUrl: '',
    rollerUrl: '',
    shopNowUrl: '/products/orela',
    isProductPage: false,
    teaser: true,
    qaOnly: false,
    prize: '$10',
    revision: '2026-07-15',
    customSource: 'Orela card popup',
    endpoint: 'https://a.klaviyo.com/client/subscriptions',
    flipsToWin: 3,      // Rosabella: "Match 3 cards"
    winHoldMs: 900,     // third flip (0.5 s turn) + a short look at the match, then the email step (theirs ~0.9 s)
    // things that mean "the visitor is busy in another overlay": wait until they are gone
    blockSelectors: [
      'cart-drawer.active', '.drawer.active', 'cart-notification .active', '.cart-notification.active',
      'details[open] > .menu-drawer', 'details.menu-opening', 'product-modal[open]', 'modal-dialog[open]',
      'quick-add-modal[open]', 'dialog[open]', '[role="dialog"][aria-modal="true"]',
      '#shopify-pc__banner', '.pp-drawer[open]'
    ],
    // fixed bars along the bottom of the screen the badge should sit above (the theme's sticky add-to-cart)
    bottomBarSelectors: ['sticky-atc', '.sticky-atc', '.pp-sticky.is-on', '.ls-sticky.is-on']
  };
  try {
    var user = JSON.parse(cfgEl.textContent || '{}');
    for (var k in user) if (Object.prototype.hasOwnProperty.call(user, k) && user[k] !== null && user[k] !== undefined) CFG[k] = user[k];
  } catch (e) { return; }
  if (!CFG.publicKey || !CFG.listId) return;

  var KEY_SUB = 'orela_popup_subscribed';
  var KEY_DISMISS = 'orela_popup_dismissed_until';
  var KEY_SEEN = 'orela_popup_seen';
  var KEY_REVEALED = 'orela_popup_revealed';
  var KEY_TEASER_OFF = 'orela_popup_teaser_off';
  // Grahym 2026-10-20: "constantly popping back up is annoying". The popup opens by itself at most ONCE per
  // dismissDays per browser, however it was left (X, No thanks, Shop Now, back, just leaving).
  var KEY_AUTO = 'orela_popup_autoshown_until';
  var DAY = 864e5;

  /* ---------------- storage: localStorage first, first-party cookie as fallback ---------------- */
  function lsGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, v) { try { window.localStorage.setItem(key, v); } catch (e) {} }
  function lsDel(key) { try { window.localStorage.removeItem(key); } catch (e) {} }
  function ssGet(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, v) { try { window.sessionStorage.setItem(key, v); } catch (e) {} }
  function ssDel(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }
  function ckGet(key) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function ckSet(key, v, days) {
    try {
      var c = key + '=' + encodeURIComponent(v) + '; path=/; SameSite=Lax';
      if (days) c += '; max-age=' + Math.round(days * 86400);
      if (location.protocol === 'https:') c += '; Secure';
      document.cookie = c;
    } catch (e) {}
  }
  function ckDel(key) { try { document.cookie = key + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) {} }
  function get(key) { var v = lsGet(key); return v !== null ? v : ckGet(key); }
  function put(key, v, days) { lsSet(key, v); ckSet(key, v, days); }

  function isSubscribed() { return get(KEY_SUB) === '1'; }
  function markSubscribed() { put(KEY_SUB, '1', 3650); lsDel(KEY_DISMISS); ckDel(KEY_DISMISS); }
  function isDismissed() { var until = parseInt(get(KEY_DISMISS) || '0', 10); return until > Date.now(); }
  function markDismissed() { var days = +CFG.dismissDays || 30; put(KEY_DISMISS, String(Date.now() + days * DAY), days); }
  // the session flag lives in sessionStorage and a session cookie, so other tabs of the same visit see it too
  function seenThisSession() { return ssGet(KEY_SEEN) === '1' || ckGet(KEY_SEEN) === '1'; }
  function markSeen() { ssSet(KEY_SEEN, '1'); ckSet(KEY_SEEN, '1', 0); }
  function autoShownRecently() { var until = parseInt(get(KEY_AUTO) || '0', 10); return until > Date.now(); }
  function markAutoShown() { var days = +CFG.dismissDays || 30; put(KEY_AUTO, String(Date.now() + days * DAY), days); }
  function wasRevealed() { return get(KEY_REVEALED) === '1'; }
  function markRevealed() { put(KEY_REVEALED, '1', +CFG.dismissDays || 30); }
  function teaserOff() { return ssGet(KEY_TEASER_OFF) === '1' || ckGet(KEY_TEASER_OFF) === '1'; }
  function markTeaserOff() { ssSet(KEY_TEASER_OFF, '1'); ckSet(KEY_TEASER_OFF, '1', 0); }
  function resetFlags() {
    [KEY_SUB, KEY_DISMISS, KEY_REVEALED, KEY_AUTO].forEach(function (k) { lsDel(k); ckDel(k); });
    [KEY_SEEN, KEY_TEASER_OFF].forEach(function (k) { ssDel(k); ckDel(k); });
  }
  // QA hook from the console, there even when this visitor will not see the popup: OrelaPopup.reset()
  var api = window.OrelaPopup = { reset: resetFlags };

  /* ---------------- where are we ---------------- */
  function currentPath() {
    var p = (location.pathname || '/').toLowerCase();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    base = String(base).toLowerCase();
    if (base !== '/' && p.indexOf(base) === 0) p = '/' + p.slice(base.length);
    else if (base !== '/' && p + '/' === base) p = '/';
    return p.replace(/\/+$/, '') || '/';
  }
  function isExcluded(p) {
    var rules = CFG.excludePaths || [];
    for (var i = 0; i < rules.length; i++) {
      var r = String(rules[i] || '').trim().toLowerCase();
      if (!r) continue;
      if (r.slice(-1) === '*') { if (p.indexOf(r.slice(0, -1)) === 0) return true; }
      else if (p === (r.replace(/\/+$/, '') || '/')) return true;
    }
    return false;
  }
  function params() { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; }, has: function () { return false; } }; } }
  function fromKlaviyo(q) {
    var src = (q.get('utm_source') || '').toLowerCase();
    var med = (q.get('utm_medium') || '').toLowerCase();
    return q.has('_kx') || src === 'klaviyo' || med === 'email' || med === 'sms';
  }

  var mq = function (s) { try { return window.matchMedia(s).matches; } catch (e) { return false; } };
  var reduceMotion = function () { return mq('(prefers-reduced-motion: reduce)'); };
  var finePointer = function () { return mq('(hover: hover) and (pointer: fine)'); };
  var saveData = function () { var c = navigator.connection; return !!(c && c.saveData); };
  var now = function () { return (window.performance && performance.now) ? performance.now() : Date.now(); };

  /* ---------------- should it show at all ---------------- */
  var q = params();
  var mode = (q.get('orp_popup') || '').toLowerCase();
  if (mode === 'reset') resetFlags();
  var force = mode === '1' || mode === 'preview' || mode === 'open';
  // Orela 2026-10-13: qaOnly = installed but not public yet (brand.json popup.live false). Only ?orp_popup=1 opens it,
  // and no badge shows, so real visitors are never promised a code before the welcome flow can send one.
  if (CFG.qaOnly && !force) return;

  if (fromKlaviyo(q)) { markSubscribed(); return; }
  // Grahym 2026-10-17: "should only show up if they havent entered their info before". Klaviyo's __kla_id cookie
  // carries $exchange_id / $email / $phone_number once Klaviyo knows who this browser is (clicked an email, signed
  // up in any Klaviyo form, typed an email at checkout). Known = treat as signed up, never show.
  function klaCookieKnown() {
    try {
      var raw = ckGet('__kla_id'); if (!raw) return false;
      var o = JSON.parse(atob(decodeURIComponent(raw)));
      return !!(o && (o.$exchange_id || o.$email || o.$phone_number));
    } catch (e) { return false; }
  }
  if (!force && klaCookieKnown()) { markSubscribed(); return; }
  if (isExcluded(currentPath())) return;
  if (!force && isSubscribed()) return;
  // first visit of the session and not dismissed: it opens by itself. Otherwise only the badge shows.
  var autoOpen = force || !(isDismissed() || seenThisSession() || autoShownRecently());

  /* ---------------- elements ---------------- */
  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var logo = $('[data-orp-logo]');
  var bottle = $('[data-orp-bottle]');
  var roller = $('[data-orp-roller]');
  var closeBtn = $('[data-orp-close]');
  var backdrop = $('[data-orp-backdrop]');
  var scrim = $('[data-orp-scrim]');
  var panel = $('[data-orp-panel]');
  var content = $('.orp-pop__content');
  var cardsWrap = $('[data-orp-cards]');
  var cards = [].slice.call(root.querySelectorAll('[data-orp-card]'));
  var emailForm = $('[data-orp-form="email"]');
  var smsForm = $('[data-orp-form="sms"]');
  var emailInput = $('#orp-email');
  var phoneInput = $('#orp-phone');
  var ccSelect = $('[data-orp-cc]');
  var skipBtn = $('[data-orp-skip]');
  var shopLink = $('[data-orp-shop]');
  var live = $('[data-orp-live]');
  var teaser = document.querySelector('[data-orp-teaser]');
  var teaserOpen = teaser && teaser.querySelector('[data-orp-teaser-open]');
  var teaserX = teaser && teaser.querySelector('[data-orp-teaser-x]');
  var steps = {};
  [].forEach.call(root.querySelectorAll('.orp-step'), function (s) { steps[s.getAttribute('data-step')] = s; });

  var state = {
    open: false, closing: false, step: null, pendingStep: null, email: '', revealed: false, lastFocus: null,
    scrollY: 0, bodyStyle: null, prefetched: false, inerted: [], readyAt: 0, flips: 0
  };

  /* ---------------- events for analytics (no personal data in them) ---------------- */
  function emit(name, detail) {
    detail = detail || {};
    detail.step = state.step;
    try { document.dispatchEvent(new CustomEvent('orela:popup:' + name, { detail: detail })); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('orela_popup_' + name, { step: state.step });
      }
    } catch (e) {}
  }

  /* ---------------- timing: delay after the page is ready, never over another overlay ---------------- */
  function isVisible(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0.05;
  }
  function isBlocked(ignoreTyping) {
    var b = document.body;
    if (!b) return true;
    if (/(^|\s)overflow-hidden(\s|$|-)/.test(b.className)) return true;
    var sels = CFG.blockSelectors || [];
    for (var i = 0; i < sels.length; i++) {
      var list;
      try { list = document.querySelectorAll(sels[i]); } catch (e) { continue; }
      for (var j = 0; j < list.length; j++) {
        if (!root.contains(list[j]) && list[j] !== root && !(teaser && teaser.contains(list[j])) && isVisible(list[j])) return true;
      }
    }
    if (ignoreTyping) return false;
    var a = document.activeElement;
    if (a && a !== b && !root.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== 'checkbox' && a.type !== 'radio') return true;
    return false;
  }
  function whenClear(fn) {
    var wasBlocked = false, clearSince = 0;
    (function tick() {
      if (state.open) return;
      var busy = isBlocked() || document.visibilityState === 'hidden';
      if (busy) { wasBlocked = true; clearSince = 0; return setTimeout(tick, 400); }
      if (!wasBlocked) return fn();
      if (!clearSince) clearSince = Date.now();
      if (Date.now() - clearSince >= 800) return fn();
      setTimeout(tick, 200);
    })();
  }
  // window load, or readyCapMs after DOMContentLoaded, whichever comes first
  function afterReady(fn) {
    var done = false;
    function go() { if (!done) { done = true; fn(); } }
    if (document.readyState === 'complete') return go();
    window.addEventListener('load', go, { once: true });
    function cap() { setTimeout(go, Math.max(0, +CFG.readyCapMs || 0)); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cap, { once: true });
    else cap();
  }

  // Rosabella's desktop layout (bottle + roller) starts at 1024 px; phones and tablets get no product images
  function wide() { return mq('(min-width: 1024px)'); }
  function prefetch() {
    if (state.prefetched) return;
    state.prefetched = true;
    try {
      var urls = [CFG.logoUrl];
      if (wide()) urls.push(CFG.bottleUrl, CFG.rollerUrl);
      urls.forEach(function (u) { if (u) { var i = new Image(); i.decoding = 'async'; i.src = u; } });
      var l = document.createElement('link');
      l.rel = 'preconnect'; l.href = 'https://a.klaviyo.com'; l.crossOrigin = 'anonymous';
      document.head.appendChild(l);
    } catch (e) {}
  }
  function loadImages() {
    if (logo && CFG.logoUrl && !logo.getAttribute('src')) logo.src = CFG.logoUrl;
    if (!wide()) return;
    if (bottle && CFG.bottleUrl && !bottle.getAttribute('src')) bottle.src = CFG.bottleUrl;
    if (roller && CFG.rollerUrl && !roller.getAttribute('src')) roller.src = CFG.rollerUrl;
  }

  // klaviyo.isIdentified() resolves true when Klaviyo already knows this browser; 1.5 s cap so a slow or blocked
  // klaviyo.js never holds the popup back for new visitors
  function knownToKlaviyo(cb) {
    var done = false;
    function fin(v) { if (!done) { done = true; cb(!!v); } }
    if (force) return fin(false);
    try {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        var r = k.isIdentified();
        if (r && typeof r.then === 'function') { r.then(fin, function () { fin(false); }); setTimeout(function () { fin(false); }, 1500); return; }
        return fin(r);
      }
    } catch (e) {}
    fin(false);
  }

  // Grahym 2026-10-31: "make the pop up come up after like 10 seconds if the person isnt in cart or checkout, only on the pdp"
  // (+ "actually 5 seconds in"). The auto-open is skipped for the visit once they press add to cart / buy / checkout (the
  // PDP form posts to /cart/add, buttons name="add" and data-sticky-submit) or already have something in the cart
  // (/cart.js item_count). The cart page itself is excluded in the snippet; checkout is Shopify's own page. The badge and
  // ?orp_popup=1 paths are unchanged.
  var shopping = false;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/cart(\/add)?(\?|$|\/)/.test(f.getAttribute('action') || '')) shopping = true;
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="add"], [data-sticky-submit], [data-main-atc], [name="checkout"], a[href*="/checkout"], a[href$="/cart"], .shopify-payment-button');
    if (t) shopping = true;
  }, true);
  function cartBusy(cb) {
    if (shopping) return cb(true);
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cb(shopping || !!(c && c.item_count > 0)); }, function () { cb(shopping); });
    } catch (e) { cb(shopping); }
  }
  function autoTry() {
    cartBusy(function (busy) {
      if (busy) return;
      whenClear(function () { if (!shopping) tryOpen(); });
    });
  }

  afterReady(function () {
    state.readyAt = now();
    knownToKlaviyo(function (known) {
      if (known) { markSubscribed(); hideTeaser(true); return; }
      if (autoOpen) {
        var delay = Math.max(0, +CFG.delayMs || 0);
        setTimeout(prefetch, Math.max(0, delay - 1200));
        setTimeout(autoTry, delay);
      } else {
        setTimeout(function () { updateTeaser(); }, 600);
      }
    });
  });

  /* ---------------- scroll lock that keeps the page where it was ---------------- */
  function lockScroll() {
    var b = document.body, h = document.documentElement;
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    var sbw = window.innerWidth - h.clientWidth;
    state.bodyStyle = { position: b.style.position, top: b.style.top, left: b.style.left, right: b.style.right, width: b.style.width, overflow: b.style.overflow, paddingRight: b.style.paddingRight };
    b.style.position = 'fixed';
    b.style.top = (-state.scrollY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    if (sbw > 0) b.style.paddingRight = sbw + 'px';
    h.classList.add('orp-pop-locked');
  }
  function unlockScroll() {
    var b = document.body, h = document.documentElement, s = state.bodyStyle || {};
    for (var k in s) b.style[k] = s[k] || '';
    h.classList.remove('orp-pop-locked');
    var prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: state.scrollY, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, state.scrollY); }
    if (Math.abs((window.scrollY || 0) - state.scrollY) > 1) window.scrollTo(0, state.scrollY);
    h.style.scrollBehavior = prev;
  }

  /* ---------------- the rest of the page is inert while the dialog is open (screen readers stay inside) ---------------- */
  function setInert(on) {
    if (on) {
      state.inerted = [];
      for (var el = root; el && el.parentElement && el !== document.body; el = el.parentElement) {
        [].forEach.call(el.parentElement.children, function (sib) {
          if (sib === el || sib.inert || /^(SCRIPT|LINK|STYLE|TEMPLATE|NOSCRIPT|META)$/.test(sib.tagName)) return;
          try { sib.inert = true; state.inerted.push(sib); } catch (e) {}
        });
      }
    } else {
      (state.inerted || []).forEach(function (sib) { try { sib.inert = false; } catch (e) {} });
      state.inerted = [];
    }
  }

  /* ---------------- open / close ---------------- */
  // never open unstyled: the stylesheet loads without blocking render, so wait for it if it is late
  function tryOpen(opts) {
    if (state.open) return;
    if (window.getComputedStyle(root).position !== 'fixed') {
      setTimeout(function () { whenClear(function () { tryOpen(opts); }); }, 250);
      return;
    }
    open(opts);
  }

  function open(opts) {
    opts = opts || {};
    if (state.open) return;
    if (!force && !opts.manual && (isSubscribed() || isDismissed() || autoShownRecently() || ckGet(KEY_SEEN) === '1')) return;
    prefetch();
    hideTeaser(true);
    state.open = true;
    state.closing = false;
    state.openedAt = now();
    markSeen();
    if (!opts.manual) markAutoShown();
    state.lastFocus = document.activeElement;

    loadImages();
    shopLink.setAttribute('href', CFG.shopNowUrl || '/products/orela');

    lockScroll();
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    // a manual reopen (badge / OrelaPopup.open()) after the cards were already matched starts at the email step
    var start = (opts.manual && (state.revealed || wasRevealed())) ? 'email' : (state.revealed ? (state.step || 'email') : 'game');
    if (start !== 'game') state.revealed = true;
    showStep(start, true);
    setInert(true);
    try { root.focus({ preventScroll: true }); } catch (e) { root.focus(); }
    if (opts.manual && start !== 'game') focusStep(start);
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('focusin', onFocusIn, true);
    emit('open', { delayMs: state.readyAt ? Math.round(state.openedAt - state.readyAt) : null, via: opts.manual ? 'badge' : 'auto' });
  }

  function close(reason) {
    if (!state.open || state.closing) return;
    state.closing = true;
    if (!isSubscribed()) markDismissed();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('focusin', onFocusIn, true);
    clearTimeout(state.winTimer);
    emit('close', { reason: reason || 'close' });
    setTimeout(function () {
      root.hidden = true;
      setInert(false);
      unlockScroll();
      state.open = false;
      state.closing = false;
      var f = state.lastFocus;
      if (f && f !== document.body && document.documentElement.contains(f) && typeof f.focus === 'function') {
        try { f.focus({ preventScroll: true }); } catch (e) {}
      }
      updateTeaser();
    }, reduceMotion() ? 0 : 300);
  }

  /* ---------------- keyboard: Esc closes, Tab stays inside ---------------- */
  function focusables() {
    var list = root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return [].filter.call(list, function (el) {
      if (el.disabled || el.closest('[hidden]')) return false;
      if (el.getAttribute('tabindex') === '-1') return false;
      if (!el.getClientRects().length) return false;
      return window.getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function onKey(e) {
    if (!state.open) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('esc'); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === root || !root.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); first.focus(); }
  }
  function onFocusIn(e) {
    if (state.open && !root.contains(e.target)) {
      var list = focusables();
      (list[0] || root).focus({ preventScroll: true });
    }
  }

  /* close on the X and on "No thanks"; on desktop also on a real click on the dark area around the panel
     (press and release outside the panel, no drag in between) */
  closeBtn.addEventListener('click', function () { close('x'); });
  [].forEach.call(root.querySelectorAll('[data-orp-nothanks]'), function (b) {
    b.addEventListener('click', function () { emit('no_thanks'); close('no_thanks'); });
  });
  var downAt = null;
  function outside(t) { return t === scrim || t === root; }
  root.addEventListener('pointerdown', function (e) {
    downAt = outside(e.target) ? { x: e.clientX, y: e.clientY } : null;
  });
  root.addEventListener('click', function (e) {
    var d = downAt;
    downAt = null;
    if (!d || !outside(e.target) || state.step === null) return;
    if (!finePointer() || !mq('(min-width: 768px)')) return;
    if (Math.abs(e.clientX - d.x) > 6 || Math.abs(e.clientY - d.y) > 6) return;
    close('backdrop');
  });

  /* ---------------- steps ---------------- */
  function showStep(name, instant) {
    var next = steps[name], cur = state.step ? steps[state.step] : null;
    if (!next || cur === next || state.pendingStep === name) return;
    state.pendingStep = name;
    function swap() {
      // hide every other step, not only the current one (a reopen can start straight at email)
      for (var k in steps) if (steps[k] !== next) { steps[k].hidden = true; steps[k].classList.remove('is-leaving'); }
      next.hidden = false;
      state.step = name;
      state.pendingStep = null;
      root.setAttribute('aria-labelledby', next.getAttribute('aria-labelledby'));
      root.setAttribute('data-step', name);
      if (backdrop) backdrop.scrollTop = 0;
      if (!state.open || state.closing) return; // closed mid cross-fade: swap quietly, no focus, no analytics
      if (!instant) focusStep(name);
      emit('step', { name: name });
    }
    if (cur && !instant && !reduceMotion()) {
      cur.classList.add('is-leaving');
      setTimeout(swap, 150);
    } else swap();
  }
  function focusStep(name) {
    var target = null;
    if (finePointer()) {
      if (name === 'email') target = emailInput;
      if (name === 'sms') target = phoneInput;
    }
    if (!target) target = steps[name].querySelector('.orp-h');
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  /* ---------------- the cards: flip 3, all 3 are the prize, so it is always a match ---------------- */
  function cardLabel(i, flipped) {
    return 'Card ' + (i + 1) + ' of ' + cards.length + (flipped ? ', ' + CFG.prize + ' gift card' : ', face down. Flip it.');
  }
  cards.forEach(function (c, i) {
    c.addEventListener('click', function () {
      if (state.revealed || state.step !== 'game' || c.classList.contains('is-flipped')) return;
      c.classList.add('is-flipped');
      c.setAttribute('aria-label', cardLabel(i, true));
      c.setAttribute('aria-disabled', 'true');
      state.flips += 1;
      emit('flip', { n: state.flips });
      if (state.flips === 1) emit('game_start');
      if (state.flips >= (+CFG.flipsToWin || 3)) win();
      else live.textContent = CFG.prize + ' gift card. ' + ((+CFG.flipsToWin || 3) - state.flips) + ' more to go.';
    });
  });
  function win() {
    if (state.revealed) return;
    state.revealed = true;
    markRevealed();
    cards.forEach(function (c) { c.disabled = true; });
    if (cardsWrap) cardsWrap.classList.add('is-won');
    live.textContent = 'You matched 3 cards. You won a ' + CFG.prize + ' gift card.';
    if (navigator.vibrate && !finePointer()) { try { navigator.vibrate(12); } catch (e) {} }
    emit('reveal', { how: 'cards' });
    state.winTimer = setTimeout(function () {
      if (!state.open || state.closing) return;
      emit('claim');
      showStep('email');
    }, reduceMotion() ? 300 : (+CFG.winHoldMs || 900));
  }

  /* ---------------- Klaviyo ---------------- */
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function post(body, retries) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
    var url = CFG.endpoint + '?company_id=' + encodeURIComponent(CFG.publicKey);
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: CFG.revision },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      clearTimeout(timer);
      if (res.status >= 200 && res.status < 300) return res.status;
      var err = new Error('HTTP ' + res.status); err.status = res.status; throw err;
    }).catch(function (err) {
      clearTimeout(timer);
      var retryable = !err.status || err.status === 429 || err.status >= 500;
      if (retries > 0 && retryable) return wait(900).then(function () { return post(body, retries - 1); });
      throw err;
    });
  }
  function subscribe(profile, subscriptions) {
    var attrs = {};
    for (var k in profile) attrs[k] = profile[k];
    attrs.subscriptions = subscriptions;
    return post({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CFG.customSource,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: CFG.listId } } }
      }
    }, 1);
  }
  // 2026-10-07: SMS not verified in Klaviyo yet. Keep the number and a record of the consent the visitor gave
  // (time, source, the exact disclosure shown) on their profile, so they can be bulk-subscribed once SMS is live.
  function saveSmsLead(email, phone, legal) {
    var url = 'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(CFG.publicKey);
    return fetch(url, {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: CFG.revision },
      body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: {
        'SMS Phone (pending opt-in)': phone,
        'SMS Consent Given At': new Date().toISOString(),
        'SMS Consent Source': CFG.customSource,
        'SMS Consent Page': location.origin + location.pathname,
        'SMS Consent Text': legal
      } } } })
    }).then(function (res) {
      if (res.status >= 200 && res.status < 300) return res.status;
      var err = new Error('HTTP ' + res.status); err.status = res.status; throw err;
    });
  }
  function identify(email) {
    try {
      var k = window.klaviyo;
      if (k && typeof k.identify === 'function') { var r = k.identify({ email: email }); if (r && r.catch) r.catch(function () {}); }
      else if (k && typeof k.push === 'function') k.push(['identify', { email: email }]);
      else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['identify', { $email: email }]);
    } catch (e) {}
  }

  /* ---------------- forms ---------------- */
  function setBusy(form, busy) {
    var btn = form.querySelector('button[type="submit"]');
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.disabled = !!busy;
    [].forEach.call(form.querySelectorAll('input, select'), function (el) { el.readOnly = !!busy; });
  }
  function setError(form, input, msg) {
    var box = form.querySelector('[data-orp-err]');
    box.textContent = msg || '';
    if (msg) { input.setAttribute('aria-invalid', 'true'); } else { input.removeAttribute('aria-invalid'); }
  }
  function normEmail(v) { return String(v || '').trim().toLowerCase(); }
  function validEmail(v) {
    if (!v || v.length > 254) return false;
    if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,}$/i.test(v)) return false;
    var local = v.split('@')[0];
    return local.length <= 64 && local.charAt(0) !== '.' && local.slice(-1) !== '.' && v.indexOf('..') === -1;
  }
  function toE164(raw, cc) {
    var s = String(raw || '').trim();
    var d = s.replace(/\D/g, '');
    if (!d) return null;
    if (s.charAt(0) === '+') return /^[1-9]\d{7,14}$/.test(d) ? '+' + d : null;
    if (d.indexOf('00') === 0 && d.length > 10) { d = d.slice(2); return /^[1-9]\d{7,14}$/.test(d) ? '+' + d : null; }
    if (cc === '1') {
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(d) ? '+1' + d : null;
    }
    if (cc === '44') {
      if (d.indexOf('44') === 0 && d.length >= 12) d = d.slice(2);
      d = d.replace(/^0/, '');
      return /^7\d{9}$/.test(d) ? '+44' + d : null;
    }
    return /^\d{6,14}$/.test(d) ? '+' + cc + d : null;
  }

  emailInput.addEventListener('input', function () { if (emailInput.getAttribute('aria-invalid')) setError(emailForm, emailInput, ''); });
  phoneInput.addEventListener('input', function () { if (phoneInput.getAttribute('aria-invalid')) setError(smsForm, phoneInput, ''); });

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (emailForm.getAttribute('data-busy')) return;
    var email = normEmail(emailInput.value);
    emailInput.value = email;
    if (!validEmail(email)) {
      setError(emailForm, emailInput, email ? 'Please check your email address.' : 'Please enter your email address.');
      emailInput.focus();
      return;
    }
    setError(emailForm, emailInput, '');
    emailForm.setAttribute('data-busy', '1');
    setBusy(emailForm, true);
    subscribe({ email: email }, { email: { marketing: { consent: 'SUBSCRIBED' } } }).then(function () {
      state.email = email;
      markSubscribed();
      identify(email);
      emit('signup', { channel: 'email' });
      // done: stop the spinner but keep the form locked (data-busy stays) so a second submit cannot send twice
      setBusy(emailForm, false);
      [].forEach.call(emailForm.querySelectorAll('input'), function (el) { el.readOnly = true; });
      if (!state.open || state.closing) { updateTeaser(); return; } // closed while sending: the signup counts, no step change
      showStep(CFG.smsEnabled ? 'sms' : 'success');
    }, function (err) {
      setBusy(emailForm, false);
      emailForm.removeAttribute('data-busy');
      setError(emailForm, emailInput, err && err.status === 400 ? 'Please check your email address.' : 'Something went wrong. Please try again.');
      emit('error', { channel: 'email', status: (err && err.status) || 0 });
      if (state.open && !state.closing) emailInput.focus();
    });
  });

  if (ccSelect) {
    var country = (window.Shopify && window.Shopify.country) || '';
    [].forEach.call(ccSelect.options, function (o) { if (o.getAttribute('data-country') === country) o.selected = true; });
  }

  smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (smsForm.getAttribute('data-busy')) return;
    var cc = ccSelect ? ccSelect.value : '1';
    var phone = toE164(phoneInput.value, cc);
    if (!phone) {
      setError(smsForm, phoneInput, phoneInput.value.trim() ? 'Please enter a valid mobile number.' : 'Please enter your mobile number.');
      phoneInput.focus();
      return;
    }
    setError(smsForm, phoneInput, '');
    smsForm.setAttribute('data-busy', '1');
    setBusy(smsForm, true);
    var profile = { phone_number: phone };
    if (state.email) profile.email = state.email;
    var legalEl = document.getElementById('orp-sms-legal');
    var saving = CFG.smsLive || !state.email
      ? subscribe(profile, { sms: { marketing: { consent: 'SUBSCRIBED' } } })
      : saveSmsLead(state.email, phone, legalEl ? legalEl.textContent.replace(/\s+/g, ' ').trim() : '');
    saving.then(function () {
      emit('signup', { channel: 'sms' });
      setBusy(smsForm, false);
      [].forEach.call(smsForm.querySelectorAll('input, select'), function (el) { el.readOnly = true; });
      if (!state.open || state.closing) return;
      showStep('success');
    }, function (err) {
      setBusy(smsForm, false);
      smsForm.removeAttribute('data-busy');
      setError(smsForm, phoneInput, err && err.status === 400 ? 'Please enter a valid mobile number.' : 'Something went wrong. Please try again.');
      emit('error', { channel: 'sms', status: (err && err.status) || 0 });
      if (state.open && !state.closing) phoneInput.focus();
    });
  });
  skipBtn.addEventListener('click', function () {
    if (state.step !== 'sms' || state.pendingStep) return;
    emit('sms_skip');
    showStep('success');
  });

  // Shop Now always closes the popup (so Back from the product page never finds it still open);
  // on a product page it only closes, elsewhere the link goes on to the product
  shopLink.addEventListener('click', function (e) {
    emit('shop_now');
    if (CFG.isProductPage) e.preventDefault();
    close('shop_now');
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && state.open && isSubscribed()) close('restore');
  });

  /* ---------------- the badge: bottom-left, reopens the offer after a close ---------------- */
  var teaserTimer = 0, barFrame = 0;
  function teaserWanted() {
    return !!teaser && CFG.teaser !== false && !state.open && !isSubscribed() && !teaserOff() && (isDismissed() || seenThisSession() || autoShownRecently());
  }
  function bottomBarHeight() {
    var sels = CFG.bottomBarSelectors || [], hgt = 0;
    for (var i = 0; i < sels.length; i++) {
      var list;
      try { list = document.querySelectorAll(sels[i]); } catch (e) { continue; }
      for (var j = 0; j < list.length; j++) {
        if (!isVisible(list[j])) continue;
        var r = list[j].getBoundingClientRect();
        if (r.bottom >= window.innerHeight - 2 && r.top < window.innerHeight) hgt = Math.max(hgt, window.innerHeight - r.top);
      }
    }
    return Math.round(hgt);
  }
  function placeTeaser() {
    barFrame = 0;
    if (teaser && !teaser.hidden) teaser.style.setProperty('--orp-bar-h', bottomBarHeight() + 'px');
  }
  function queuePlace() {
    if (!barFrame) barFrame = (window.requestAnimationFrame || setTimeout)(placeTeaser);
    clearTimeout(state.placeTimer);
    state.placeTimer = setTimeout(placeTeaser, 220); // again once the theme's bar has finished sliding
  }
  function showTeaser() {
    if (!teaser) return;
    clearTimeout(teaserTimer); // also cancels a hide that is still fading out
    if (!teaser.hidden && teaser.classList.contains('is-in')) return;
    var wasHidden = teaser.hidden;
    teaser.hidden = false;
    placeTeaser();
    void teaser.offsetWidth;
    teaser.classList.add('is-in');
    window.addEventListener('scroll', queuePlace, { passive: true });
    window.addEventListener('resize', queuePlace);
    if (wasHidden) emit('badge_show');
  }
  function hideTeaser(instant) {
    if (!teaser || teaser.hidden) return;
    var leaving = !teaser.classList.contains('is-in');
    teaser.classList.remove('is-in');
    window.removeEventListener('scroll', queuePlace);
    window.removeEventListener('resize', queuePlace);
    if (leaving && !instant) return; // already fading out
    clearTimeout(teaserTimer);
    if (instant || reduceMotion()) teaser.hidden = true;
    else teaserTimer = setTimeout(function () { teaser.hidden = true; }, 260);
  }
  // shown when wanted, tucked away while a drawer, menu, modal or the cookie banner is open
  function updateTeaser() {
    if (teaserWanted() && !isBlocked(true)) showTeaser();
    else hideTeaser();
  }
  if (teaser) {
    if (typeof MutationObserver === 'function') {
      var moFrame = 0;
      var mo = new MutationObserver(function () {
        if (moFrame) return;
        moFrame = setTimeout(function () { moFrame = 0; if (state.readyAt && !state.open) updateTeaser(); }, 120);
      });
      try { mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'open'], subtree: true }); } catch (e) {}
    }
    teaserOpen.addEventListener('click', function () {
      emit('badge_open');
      tryOpen({ manual: true });
    });
    teaserX.addEventListener('click', function () {
      markTeaserOff();
      emit('badge_hide');
      hideTeaser();
    });
  }

  /* small hook for QA from the console: OrelaPopup.open() / .close() / .reset() */
  api.open = function () { force = true; tryOpen({ manual: true }); };
  api.close = function () { close('api'); };
})();
